import Environment from '../common/Environment';
import Member from '../entities/Member';
import MemoComment from '../entities/MemoComment';
import MemoCommentJson from '../jsons/MemoCommentJson';

export default class GetMemoAttachment {
  execute(memoComment: MemoComment, account: Member): Promise<MemoComment> {
    const method: string = 'GET';
    const path: string =
      Environment.server() + '/memo/commentAttachment/' + memoComment.created;

    return new Promise((resolve, reject) => {
      const request = new URL(path);
      const params = new URLSearchParams();
      params.append('t', account.token);
      request.search = params.toString();

      fetch(request.toString(), {
        method,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      })
        .then((response: Response) => {
          if (response.ok) {
            return response.json();
          } else {
            reject(response.status);
            return null;
          }
        })
        .then((responseJson: MemoCommentJson) => {
          if (
            responseJson.api === undefined ||
            responseJson.api.status === undefined
          ) {
            reject('Server Error');
          } else if (responseJson.api.status === 'success') {
            resolve(responseJson.memoComment);
          } else {
            reject(responseJson.api.errorMessage);
          }
        })
        .catch(error => {
          console.log(error.message);
          reject(
            `通信に失敗しました。ネットワークに問題がある可能性があります。\n${error.message}`
          );
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/apis/GetMemoAttachment.ts